// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChatsBulkOperationsRestoreAllFromArchiveDesktopModel,
  IMappers,
  TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse,
  TChatsBulkOperationsRestoreAllFromArchiveDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createChatsBulkOperationsRestoreAllFromArchiveDesktopModel(): TChatsBulkOperationsRestoreAllFromArchiveDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v1/chats/bulk-operations/restore-all-from-archive-desktop/',
    response: {
      '200': {},
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IChatsBulkOperationsRestoreAllFromArchiveDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchChatsBulkOperationsRestoreAllFromArchiveDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IChatsBulkOperationsRestoreAllFromArchiveDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChatsBulkOperationsRestoreAllFromArchiveDesktopModel(),
    config,
  )) as FetchResponse<TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChatsBulkOperationsRestoreAllFromArchiveDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChatsBulkOperationsRestoreAllFromArchiveDesktopResponse>;
}
